<template>
    <div>
        <b-container fluid style='background:#737373; color:#FFF; margin-top:10px; margin-bottom:20px'>
            <b-modal  class="test-modal"  no-fade  scrollable size="lg" id='termsdetails' title="Terms and Conditions" 
                    ok-only ok-title ='OK' >
                <termsofuse />
            </b-modal>
            <b-row>
                <b-col>
                    <b-modal no-fade scrollable size="lg"  id="modal-termsofuse" ok-only title="Terms Of Use" ok-title="OK">
                          <termsofuse/>
                    </b-modal>
                </b-col>
            </b-row>

            <b-row style='margin-top:10px; margin-bottom:10px'>
                <b-col>
                    <label><router-link style="text-decoration: none; color:#FFF;" to="contact" >Customer Service</router-link></label>
                    <hr style='color:#fff'>
                    <b-container>
                        
                        <b-row>
                            <b-col>
                                <label><router-link style="text-decoration: none; color:#FFF;" to="contact"> <small><font-awesome-icon icon="hand-point-right" /> Customer Service</small></router-link></label>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <a  onmouseover="" style="cursor: pointer;text-decoration: none; color:#FFF; " href="mailto:info@kegseeker.com"><small><font-awesome-icon icon="envelope-open" /> info@kegseeker.com</small></a>
                            </b-col>
                        </b-row>


                    </b-container>
                </b-col>
                <b-col>
                    <label><router-link to="faq"  onmouseover="" style="cursor: pointer;text-decoration: none; color:#FFF; ">FAQ</router-link></label>
                    <hr style='color:#fff'>
                    <b-container>
                        <b-row>
                            <small>Kegseeker.com is a brewer to buyer marketplace. Breweries put up their beers for sale, buyers order them. 
                            </small>
                        </b-row>
                    </b-container>
                </b-col>
                <b-col>
                    <label @click = 'showTermsOfUse'  onmouseover="" style="cursor: pointer;" >Terms Of Use</label>
                    <hr style='color:#fff'>
                    <b-container>
                        <b-row>
                            <small>By buying beers, you certify that you are legally allowed to buy beer. By offering beers for sale, you certify you are licensed to brew and sell beers.</small>
                        </b-row>
                    </b-container>
                </b-col>
            </b-row>
            <b-row>
                <b-row>
                    <b-col>
                        <hr>
                    </b-col>
                </b-row>
                <b-col style='background:#AAA; color:#FFF'>
                    <small><font-awesome-icon icon="copyright" /> 2020 Keg Seekers LLC</small>   
                </b-col>
            <br>
            <hr>
            </b-row>     
                       
        </b-container>
    </div>
</template>

<script>
import Termsofuse from './Termsofuse'
    export default {
        components: {
            Termsofuse
        },

        data() {
            return {
                
            }
        },
        methods: {
            showTermsOfUse(){
                this.$bvModal.show("termsdetails")
                return

            }


        }
    }
</script>
<style scoped>
hr { background-color: white; height: 1px; border: 0; }
</style>